<template>
    <div>
        <v-card-title>
            <span class="headline">Właściwości</span>
        </v-card-title>
        <v-text-field
            v-model="editable.length"
            :label="$t('materials.length')"
            :error-messages="fieldErrors('length')"
            type="number"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.clearance"
            :label="$t('materials.clearance')"
            :error-messages="fieldErrors('clearance')"
            type="number"
            @input="changeValue">
        </v-text-field>
        <v-text-field
            v-model="editable.arrangement"
            :label="$t('materials.arrangement')"
            :error-messages="fieldErrors('arrangement')"
            type="number"
            @input="changeValue">
        </v-text-field>
    </div>
</template>
<script>
export default {
        name: "JoistForm",
        props: {
            item: {},
            errors: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                editable: {
                    length: 0,
                    clearance: 0,
                    arrangement: 0,
                    name: ''
                }
            }
        },
        methods: {
            fieldErrors(field) {
                return this.errors['joist.' + field] || []
            },
            changeValue(){
                this.editable.name = this.item.description.pl
                this.$emit('itemChange', this.editable)
            }
        },
        mounted() {
            if(this.item.joist)
            {
                this.editable = this.item.joist

            }
            this.changeValue()
        },

}
</script>
